import { t, type TranslatedString, type TranslationKey } from "@i18n";
import {
  resolveErrorContentWith,
  resolveThrownErrorContentWith,
  type ApiErrorBody,
  type ErrorContentTranslate,
} from "@Helpers/errorContent";

export type { ApiErrorBody };

/**
 * Web's `t`, widened to the plain-string signature `packages/helpers` resolves through.
 *
 * The cast is the same one this file always made: the mapper's sentences ARE the catalog keys, but
 * `TranslationKey` is the literal union built from en.json, which the compiler cannot know a runtime
 * string belongs to. Parity between mapper and en.json is enforced separately, not by this cast.
 *
 * This adapter is the ONLY thing web still owns here — the resolution and the `TranslatedString`
 * brand live in `@Helpers/errorContent`, shared with mobile.
 */
const translate: ErrorContentTranslate = (key, options) =>
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- see above
  t(key as TranslationKey, options);

/** Turns a failure body into the text to show the user. */
export function resolveErrorContent(body: ApiErrorBody | null | undefined): TranslatedString {
  return resolveErrorContentWith(translate, body);
}

/**
 * `resolveErrorContent` for an axios rejection, where the body sits under `error.response.data` and
 * the whole thing is `unknown` until proven otherwise.
 */
export function resolveThrownErrorContent(error: unknown): TranslatedString {
  return resolveThrownErrorContentWith(translate, error);
}
